import axios from 'axios';
import store from '../../store/index'
import api from './api.js'
import Message from 'element-ui/lib/message.js';
import router from '../../router/index'

let devBaseUrl = 'https://weixinprinthost.woquyun.com/cprint-api/'; //开发
let devBaseUrls = 'http://192.168.1.102:8383/cprint-school-api/'; //联系客服
// let devBaseUrl = 'http://192.168.1.102:8383/cprint-api/'; //开发



let proBaseUrl = 'https://weixinprinthost.woquyun.com/cprint-api/'; //生产
let proBaseUrls = 'https://weixinprinthost.woquyun.com/cprint-school-api/'; //联系客服


export default {
	request2(url, method = 'get', data, onUploadProgress) {
		let baseUrl = "";
		if (process.env.NODE_ENV === 'development') {
			console.log('开发环境')
			baseUrl = devBaseUrls;
		} else {
			console.log('生产环境')
			baseUrl = proBaseUrls;
		}
		return new Promise((resolve, reject) => {
			console.log(url)
			axios({
				url: url.indexOf('http') < 0 ? baseUrl + url : url,
				method: method,
				headers: {
					'X-WQ-TIME': new Date().getTime(),
					'X-WQ-REQID': this.generateUUID(),
					'X-WQ-UTOKEN': localStorage.getItem('token'),
				},
				timeout: 0,
				params: method == 'get' ? data : {},
				data: method == 'post' ? data : {},
				onUploadProgress: onUploadProgress,
			}).then(res => {
				resolve(res.data)
				if (res.statusCode == 200 || res.statusCode == 201) {
					resolve(res.data)
				} else {
					Message.error(res.data.message);
					reject(res.data);
				}
			}).catch(err => {
				console.log(err.response)
				if (err.response.status == 401) {
					router.push({
						path: '/login',
					})
				}
				reject(err);
			});
		})
	},
	request(url, method = 'get', data, onUploadProgress) {
		let baseUrl = "";
		if (process.env.NODE_ENV === 'development') {
			console.log('开发环境')
			baseUrl = devBaseUrl;
		} else {
			console.log('生产环境')
			baseUrl = proBaseUrl;
		}
		return new Promise((resolve, reject) => {
			console.log(url)
			axios({
				url: url.indexOf('http') < 0 ? baseUrl + url : url,
				method: method,
				headers: {
					'X-WQ-TIME': new Date().getTime(),
					'X-WQ-REQID': this.generateUUID(),
					'X-WQ-UTOKEN': localStorage.getItem('token'),
				},
				timeout: 0,
				params: method == 'get' ? data : {},
				data: method == 'post' ? data : {},
				onUploadProgress: onUploadProgress,
			}).then(res => {
				if (res.status == 200 || res.status == 201) {
					resolve(res.data)
				} else {
					Message.error(res.data.message);
					reject(res.data);
				}
			}).catch(err => {
				console.log(err.response)
				if (err.response.status == 401) {
					router.push({
						path: '/login',
					})
				}
				reject(err);
			});
		})
	},
	requestBlob(url, method = 'get', data, onUploadProgress) {
		let baseUrl = "";
		if (process.env.NODE_ENV === 'development') {
			console.log('开发环境')
			baseUrl = devBaseUrl;
		} else {
			console.log('生产环境')
			baseUrl = proBaseUrl;
		}
		console.log(store)
		return new Promise((resolve, reject) => {
			axios({
				url: url.indexOf('http') < 0 ? baseUrl + url : url,
				method: method,
				headers: {
					'X-WQ-TIME': new Date().getTime(),
					'X-WQ-REQID': this.generateUUID(),
					'X-WQ-UTOKEN': localStorage.getItem('token'),
				},
				timeout: 0,
				params: method == 'get' ? data : {},
				data: method == 'post' ? data : {},
				onUploadProgress: onUploadProgress,
				responseType: 'blob'
			}).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err);
			});
		})
	},
	getUploadToken(path = 'p0') { //获取文件上传token
		return new Promise((resolve, reject) => {
			this.request(api.getUpLoadInfo, 'get', {
				path: path
			}).then(res => {
				store.commit('setUploadInfo', {
					uploadToken: res.token,
					mainUrl: res.mainUrl,
					uploadUrl: res.mainUrl + '/files/upload-to-pdf',
				})
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	},
	fileUpload(files, path = 'p0', keywordsFlag = '0') { //上传文件
		// 校验格式
		// let limitAuffixArr = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf']
		return new Promise((resolve, reject) => {
			// 最多上传10个
			let flag = false;
			// for (let item of files) {
			// 	let suffixArr = item.name.match(/\.[^\.]+$/);
			// 	if (suffixArr.length > 0 && limitAuffixArr.includes(suffixArr[suffixArr.length - 1])) {} else {
			// 		Message.error('仅支持word,excel,ppt,pdf');
			// 		flag = true;
			// 		reject('');
			// 		break;
			// 	}
			// }
			if (flag) return;
			store.commit('clearUploadPro'); //清空文件上传arr
			store.commit('changeUploadPopShow', true); //显示文件上传进度
			let promiseArr = [];
			let index = 0;
			// 转换进度
			let transformInte = setInterval(() => {
				let flag = false;
				for (let item of store.state.uploadPro) {
					if (item.tprogress && item.tprogress != 100) {
						if (store.state.uploadPopShow == false) {
							flag = true;
							item.tprogress = 100;
						} else {
							if (item.tprogress < 50) {
								item.tprogress = parseInt(item.tprogress);
								item.tprogress += 1;
							} else if (item.tprogress < 90) {
								item.tprogress = parseFloat(item.tprogress);
								item.tprogress += 0.5;
							} else if (item.tprogress < 100) {
								item.tprogress = parseFloat(item.tprogress);
								item.tprogress += 0.01;
								item.tprogress = item.tprogress.toFixed(2);
							} else {

							}
						}
						store.commit('updateUploadProByIndex', item);
					}
				}
				if (flag) {
					clearInterval(transformInte);
				}
			}, 1000);
			for (let item of files) {
				promiseArr.push(new Promise((resolve2, reject2) => {
					//上传进度
					let index2 = parseInt(index);
					if (!store.state.uploadPro[index2]) {
						store.commit('addUploadPro', {
							name: item.name ? item.name : item.path,
							progress: 0
						})
					}

					let formData = new FormData();
					formData.append('fileName', item.name)
					formData.append('token', store.state.uploadInfo.uploadToken)
					formData.append('file', item)

					this.request(store.state.uploadInfo.uploadUrl, 'post', formData, (uploadPro) => {
						let progress = Math.round((uploadPro.loaded / uploadPro.total).toFixed(2) * 100);
						console.log(progress)
						store.commit('updateUploadProByIndex', {
							index: index2,
							name: item.name ? item.name : item.path,
							progress: progress
						})
						if (progress == 100) {
							store.commit('updateUploadProByIndex', {
								index: index2,
								name: item.name ? item.name : item.path,
								progress: 100,
								tprogress: 1,
							})
						}
					}).then(res => {
						resolve2(res.data)
					}).catch(err => {
						console.log(err.response.data)
						clearInterval(transformInte);
						store.commit('changeUploadPopShow', false);
						store.commit('setUploadFlag', false);
						store.commit('setUploadFlag', true);
						Message.error(err.response.data.message);
						// reject2(err);
					})
				}))
				index++;
			}
			Promise.all(promiseArr).then(res => {
				var progressUrl = "";
				if (process.env.NODE_ENV === 'development') {
					progressUrl = devBaseUrl + 'v1.0/files/progress';
				} else {
					progressUrl = proBaseUrl + 'v1.0/files/progress';
				}
				// 查询上传进度
				let finish = false;
				let formData = new FormData();
				formData.append('token', store.state.uploadInfo.uploadToken)
				formData.append('keywordsFlag', keywordsFlag)
				let interval = setInterval(() => {
					this.request(progressUrl, 'post', formData).then(res2 => {
						// if (res2.statusCode != 200) {
						// 	clearInterval(interval);
						// 	clearInterval(transformInte);
						// 	store.commit('changeUploadPopShow', false);
						// 	console.log(Message)
						// 	Message.error('上传失败!');
						// }
						let fileStatus = res2;
						if (fileStatus.failNum > 0) {
							clearInterval(interval);
							clearInterval(transformInte);
							store.commit('changeUploadPopShow', false);
							let sucFileList = [],
								errFileList = [];
							for (let item of fileStatus.items) {
								if (item.errMsg) {
									errFileList.push(item);
								} else {
									sucFileList.push(item);
								}
							}
							if (sucFileList.length > 0) {
								if (path == "p0") this.uploadSucFile(sucFileList)
								store.commit('setUploadSucList', sucFileList);
							}
							if (errFileList.length > 0) {
								store.commit('setUploadErrorList', errFileList);
								store.commit('setUploadErrorShow', true);
							}
							// resolve()
						} else if (fileStatus.succNum == fileStatus.total) {
							store.commit('setUploadSucList', fileStatus.items);
							//封装filelist
							if (!finish) {
								finish = true;
								// store.commit('setFileList', fileStatus.items);
								if (path == "p0") this.uploadSucFile(fileStatus.items)
								store.commit('changeUploadPopShow', false);
								store.commit('setUploadFlag', false);
								store.commit('setUploadFlag', true);
								clearInterval(transformInte);
								resolve()
								clearInterval(interval);
							}
						}
						// store.commit('updateUploadProByIndex', {
						// 	index: index2,
						// 	name: item.name ? item.name : item.path,
						// 	progress: 100,
						// 	tprogress: 100,
						// })
						for (let item of store.state.uploadPro) {
							item.tprogress = 100;
							store.commit('updateUploadProByIndex', item);
						}
					}).catch(err => {
						clearInterval(interval);
						clearInterval(transformInte);
						store.commit('changeUploadPopShow', false);
						Message.error('上传失败!');
					})
				}, 2000)

			}).catch(err => {
				store.commit('changeUploadPopShow', false);
				Message.error('上传失败!');
				console.log(err)
				reject(err);
			})
		})
	},
	uploadSucFile(files) {
		let limitAuffixArr = ['jpg', 'jpeg', 'png'];
		for (let item of files) {
			item.ifColor = limitAuffixArr.indexOf(item.extName) > -1 ? 1 : 0;
			item.startPage = 1;
			item.endPage = item.pdfPageNum;
			item.copyNum = 1;
			item.pageSize = 1;
			item.ifDuplex = item.pdfPageNum > 1 ? 1 : 0;
			item.duplexType = 1;
			item.shrinkPlateNum = 11;
		}
		this.request(api.addCarts, 'post', {
			fileItems: files
		})
	},
	formatDayMin(inputTime) { // 时间戳转化成正常时间
		var date = new Date(inputTime);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		var h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		var minute = date.getMinutes();
		var second = date.getSeconds();
		minute = minute < 10 ? ('0' + minute) : minute;
		return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
	},

	formatDayMins(inputTime) { // 时间戳转化成正常时间
		var date = new Date(inputTime);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		var h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		var minute = date.getMinutes();
		var second = date.getSeconds();
		minute = minute < 10 ? ('0' + minute) : minute;
		return y + '-' + m + '-' + d;
	},

	resultFormat(result) {
		result = Math.abs(result)
		var h = Math.floor(result / 3600 % 24);
		var m = Math.floor(result / 60 % 60);
		if (h < 1) {
			return result = m + "分钟";
		} else {
			return result = h + "小时" + m + "分钟";
		}
	},

	generateUUID() {
		var s = [];
		var hexDigits = "0123456789abcdef";
		for (var i = 0; i < 36; i++) {
			s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
		}
		s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
		s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
		s[8] = s[13] = s[18] = s[23] = "";

		var uuid = s.join("");
		return uuid;
	},
}
